import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const MultiUserPickerEditViewEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-team-edit-view" */ './ui/team'),
	),
	getPreloadProps: () => ({}),
});
export default MultiUserPickerEditViewEntryPoint;
